module.exports = __webpack_public_path__ + "static/media/noimage.124987e1.jpg";